import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce, orderBy } from "lodash";
import draggable from "vuedraggable";
import { mapState, mapActions } from "vuex";
import { UPDATE_REQUEST_LIST_ORDER, SAVE_REQUEST_LIST_ORDER } from "../../../store/documents-actions";
import DocumentRequestListCollapse from "./document-request-list-collapse";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentRequestList",
  components: {
    draggable,
    DocumentRequestListCollapse
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    documentRequestListName: {
      type: String,
      required: true
    },
    documentRequestsIds: {
      type: Array,
      required: true
    },
    draftDocumentRequestList: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState("DocumentsStore", {
    documentRequests(state) {
      var _context;
      return _mapInstanceProperty(_context = this.documentRequestsIds).call(_context, id => state.documentRequests.byId[id] || {});
    }
  })), {}, {
    noDocumentRequests() {
      return this.documentRequests.length === 0;
    },
    orderedDocumentRequests: {
      get() {
        return orderBy(this.documentRequests, "order", "asc");
      },
      set(value) {
        const newOrderedDocumentRequest = _mapInstanceProperty(value).call(value, (documentRequest, index) => {
          return _objectSpread(_objectSpread({}, documentRequest), {}, {
            order: index
          });
        });
        this.UPDATE_REQUEST_LIST_ORDER({
          documentRequestListName: this.documentRequestListName,
          documentRequests: newOrderedDocumentRequest
        });
        if (this.draftDocumentRequestList) return;
        this.saveRequestListOrder({
          documentRequestListName: this.documentRequestListName,
          documentRequests: newOrderedDocumentRequest
        });
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [UPDATE_REQUEST_LIST_ORDER, SAVE_REQUEST_LIST_ORDER])), {}, {
    handleRefreshTemplates(id) {
      this.$emit("refresh", id);
    },
    saveRequestListOrder: debounce(function ({
      documentRequestListName,
      documentRequests
    }) {
      this.SAVE_REQUEST_LIST_ORDER({
        documentRequestListName,
        documentRequests
      });
    }, 500)
  })
});